import { ResponsivePie } from "@nivo/pie";
import { colors } from "common/const/colors";
import { CustomChartTooltip } from "common/components/Etc/tooltip";
import styled from "styled-components";
import { Legend } from "common/components";

export const PieChart = ({ data, showLegend = false }) => {
  const parsedData = data.data
    .filter((item) => item.value > 0)
    .map((item, index) => ({
      ...item,
      colorIndex: index,
    }));

  const getPieColor = (datum) => {
    console.log(datum);
    const index = datum.data.colorIndex;
    const colorIndex = index % colors.BlueScale.length;
    if (
      colorIndex === 0 &&
      index > colors.BlueScale.length - 1 &&
      index === data.length - 1
    )
      return colors.BlueScale[1];

    return colors.BlueScale[colorIndex];
  };

  const total = data.data.reduce((sum, item) => sum + item.value, 0);
  const legendData = data.data.map((item, index) => ({
    color: getPieColor({
      data: {
        ...item,
        colorIndex: index,
      },
    }),
    title: item.name,
    value: item.value,
    rate: (item.value / total) * 100,
  }));

  return (
    <ChartWrapper>
      {showLegend && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: "1rem",
            flex: 1,
          }}>
          <Legend data={legendData} direction="column" />
        </div>
      )}
      <div style={{ flex: 2 }}>
        <ResponsivePie
          data={parsedData}
          margin={{ top: 30, right: 30, bottom: 30, left: 30 }}
          innerRadius={0.5}
          padAngle={0.6}
          activeOuterRadiusOffset={8}
          enableArcLinkLabels={false}
          enableArcLabels={false}
          animate={false}
          tooltip={CustomChartTooltip}
          colors={(datum) => getPieColor(datum)}
        />
      </div>
    </ChartWrapper>
  );
};

const ChartWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;
